import { PomodoroTimerMode, PomodoroTimerType } from "@lifeat/shared/widget/PomodoroTimerTypes";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import GA4Event, { GA4EventProperties } from "@analytics/GoogleAnalytics/GA4Event";
import * as GA4Service from "@analytics/GoogleAnalytics/GA4Service";
import { EndPomodoroTimerEvent, StartPomodoroTimerEvent } from "../AmplitudeWidgetEvents";

export type PomodoroAnalyticsEvent =
    | {
          eventType: "start";
          timerMode: PomodoroTimerMode;
          timerType: PomodoroTimerType;
          fromClick: boolean;
      }
    | {
          eventType: "end";
          timerMode: PomodoroTimerMode;
          timerType: PomodoroTimerType;
      };

export function PomodoroAnalyticsService(amplitudeService: AmplitudeService) {
    const ga4Event = (event: PomodoroAnalyticsEvent): GA4Event => {
        switch (event.eventType) {
            case "start":
                return GA4Event.TIMER_START;
            case "end":
                return GA4Event.TIMER_END;
        }
    };

    const amplitudeEvent = (event: PomodoroAnalyticsEvent) => {
        switch (event.eventType) {
            case "start":
                return new StartPomodoroTimerEvent({ timerType: event.timerType, timerMode: event.timerMode });
            case "end":
                return new EndPomodoroTimerEvent({ timerType: event.timerType, timerMode: event.timerMode });
        }
    };

    const log = (event: PomodoroAnalyticsEvent) => {
        GA4Service.logWidgetEvent(ga4Event(event), {
            [GA4EventProperties.timer_type.key]: event.timerType,
        });
        amplitudeService.logEvent(amplitudeEvent(event));
    };

    return { log };
}

export type PomodoroAnalyticsService = ReturnType<typeof PomodoroAnalyticsService>;
